import CountUp from "./countUp/countUp.component";

export {
    CountUp
};